<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
                Корпорации / Компании
            </div>
            <div class="content-inner">
                <div class="btn_add" @click="$router.push('/company/new')">Добавить компанию</div>
                <table>
                    <tr>
                        <th>ID</th>
                        <th>Корпорация / Компания</th>
                        <th>ИНН</th>
                        <th>Дата добавления</th>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr v-for="user_company in companies_list" :key="user_company.id">
                        <td>{{user_company.id}}</td>
                        <td>{{user_company.full_name}}</td>
                        <td>{{user_company.inn}}</td>
                        <td>{{user_company.created_at}}</td>
                        <td class="td-for-button">
                            <div class="btn_for_table" @click="$router.push('/company/'+user_company.id)">Перейти</div>
                        </td>
                        <td class="td-for-button">
                            <div class="btn_for_table_delete" @click="delete_company(user_company.id)">Удалить</div>
                        </td>
                    </tr>

                </table>
                <div class="data_empty_in_table" v-show="isTableArrayShow">
                    Добавленных компаний не найдено
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Companies',
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            companies_list: {},
        }
    },
    computed: {
        isTableArrayShow: function() {
            if(this.companies_list.length > 0)
                return false
            else    
                return true
        }
    },
    methods: {
        companies() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/user_companies')
            .then(response => {
                this.companies_list = response.data.data  
                loader.hide();
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        delete_company(company_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.delete(process.env.VUE_APP_API_URL + '/api/company/'+company_id)
            .then(response => {
                this.companies()
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide()
            })
            .catch(error => {
                //let loader = this.$loading
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.companies()
    }
}
</script>